import React, { useEffect, useRef, useState } from "react";
import "../styles/WeekdayScheduler.css";
import { TimePicker, Space, Row, Col, Popover } from "antd";
import {
  CloseCircleFilled,
  ClockCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import WeekdaySchedulerEditor from "./WeekdaySchedulerEditor";
import { RxLapTimer } from "react-icons/rx";
import { CgSandClock } from "react-icons/cg";
import moment from "moment";
import { useProLanguage, PRO_TRANSLATIONS } from "../global/ProLanguageContext";
const { RangePicker } = TimePicker;
const weekdays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
const weekdayNums = [1, 2, 3, 4, 5, 6, 0];

function WeekdaySchedulerItem(props) {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.weekdaySchedulerItem ||
    PRO_TRANSLATIONS.en.weekdaySchedulerItem;

  const [schData, setSchData] = useState(null);
  const [displayTimes, setDisplayTimes] = useState(t.noSpecificTime);
  const [displayDates, setDisplayDates] = useState(t.noSpecificDates);
  const [repeatEveryString, setRepeatEveryString] = useState(null);
  const [repeatDurationString, setRepeatDurationString] = useState(null);
  const [editorVisible, setEditorVisible] = useState(false);
  const { onRemove = () => {}, data, onSaved = () => {} } = props;
  const editorRef = useRef();
  const inputDateformat = "YYYY-MM-DD";
  const dateFormat = "DD-MM-YYYY";
  const inputformat = "HH:mm:ss";
  const format = "HH:mm";

  useEffect(() => {
    if (props.data) {
      setSchData(props.data);
    }
  }, []);

  useEffect(() => {
    if (!schData) return;
    var time = `${new moment(schData.StartTime, inputformat).format(format)} - ${new moment(schData.EndTime, inputformat).format(format)}`;
    // var days = `${schData.StartDate} - ${schData.EndDate}`
    var days = `${new moment(schData.StartDate, inputDateformat).format(dateFormat)} - ${new moment(schData.EndDate, inputDateformat).format(dateFormat)}`;

    if (schData.RepeatEvery && schData.RepeatDuration) {
      try {
        setRepeatEveryString(formatSeconds(schData.RepeatEvery));
        setRepeatDurationString(formatSeconds(schData.RepeatDuration));
      } catch (e) {
        console.log(e);
        setRepeatEveryString(null);
        setRepeatDurationString(null);
      }
    } else {
      setRepeatEveryString(null);
      setRepeatDurationString(null);
    }

    if (
      (schData.StartTime === "00:00:00" && schData.EndTime === "23:59:59") ||
      (schData.StartTime === "" && schData.EndTime === "")
    ) {
      time = t.noSpecificTime;
    }
    if (schData.StartDate === "" && schData.EndDate === "") {
      days = t.noSpecificDates;
    }

    setDisplayTimes(time);
    setDisplayDates(days);
  }, [schData, lang]);

  const formatSeconds = (seconds) => {
    const units = [
      { label: "h", value: 3600 },
      { label: "m", value: 60 },
      { label: "s", value: 1 },
    ];

    let result = [];

    for (const unit of units) {
      const unitValue = Math.floor(seconds / unit.value);
      if (unitValue > 0) {
        result.push(`${unitValue}${unit.label}`);
        seconds %= unit.value; // Get remaining seconds
      }
    }

    return result.join(" ");
  };

  const handleVisibleChanged = (visible) => {
    setEditorVisible(visible);
    if (!visible) {
      if (editorRef.current) {
        editorRef.current.resetUnsavedChanged();
      }
    }
  };

  const onWeekdayScheduleSaved = (newData) => {
    setSchData(newData);
    setEditorVisible(false);
    onSaved();
  };

  if (!schData) {
    return null;
  }
  return (
    <Popover
      onOpenChange={handleVisibleChanged}
      placement="bottom"
      trigger="click"
      open={editorVisible}
      content={
        <WeekdaySchedulerEditor
          ref={editorRef}
          data={schData}
          onSave={onWeekdayScheduleSaved}
        ></WeekdaySchedulerEditor>
      }
    >
      <div className="itemrow" style={{ position: "relative" }}>
        <div className="scheduletext scheduler">
          <div className="schedulerow">
            <div className="labelgroup" style={{ display: "inline-block" }}>
              {weekdays.map((day, index) => {
                const isActive =
                  schData.WeekDay.indexOf(`${weekdayNums[index]}`) !== -1;
                const style = isActive
                  ? "ui mini active label"
                  : "ui mini label";
                return (
                  <div key={`weekday_${day}`} className={style}>
                    {" "}
                    {day.charAt(0)}
                  </div>
                );
              })}
            </div>

            {repeatEveryString && repeatDurationString && (
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.8em",
                  backgroundColor: "#f6f6ff",
                  color: "#444",
                  padding: "0.5em",
                  borderRadius: "0.8em",
                  border: "1px dashed #dadada",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "3px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <RxLapTimer />
                  {repeatEveryString}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "3px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CgSandClock />
                  {repeatDurationString}
                </div>
              </div>
            )}
          </div>

          <div>
            <Row
              gutter={24}
              justify="start"
              style={{ padding: "0 10px", fontSize: "12px" }}
            >
              <Col>
                <Space align="start">
                  <ClockCircleOutlined />
                  {displayTimes}
                </Space>
              </Col>
              <Col>
                <Space align="end">
                  <CalendarOutlined />
                  {displayDates}
                </Space>
              </Col>
            </Row>
          </div>
        </div>
        <div
          onClick={(e) => {
            onRemove(e);
            e.preventDefault();
          }}
          className="btn-remove-item"
          style={{ position: "absolute", right: "-24px", top: 0 }}
        >
          <CloseCircleFilled
            style={{
              color: "rgb(221, 221, 221)",
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </div>
      </div>
    </Popover>
  );
}

export default WeekdaySchedulerItem;
